import {
  Box,
  Grid,
  Link,
  Alert,
  Snackbar,
  Typography,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateRegistration } from "../services/registration.service";

const CreateRegistrationFormPage = () => {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [form, setRegistrationForm] = useState({
    id: 0,
    name: "",
    title: "",
    firstName: "",
    otherName: "",
    surname: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    zipcode: "",
    dateOfBirth: "",
    utrNo: "",
    nationalInsuranceNo: "",
    nextOfKin: "",
    email: "",
    mobileNo: "",
    nextOfKinContactNo: "",
    trade: "",
    cscsCpcs: "",
    bankNameAddress: "",
    accountName: "",
    accountNo: "",
    sortCode: "",
    referenceNo: "",
    createdAt: "",
    createdBy: "",
    lastModifiedAt: "",
    lastModifiedBy: ""
  });

  const handleFieldChange = (field) => (event) => {
    setRegistrationForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSubmit = () => {
    setRegistrationForm((prev) => ({ ...prev }));
    handleSave();
  };

  const handleSave = async () => {
    try {
      const result = await updateRegistration(form);
      setOpenSnackbar(true);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setRegistrationForm((prev) => ({
      ...prev,
      title: "",
      firstName: "",
      otherName: "",
      surname: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      zipcode: "",
      dateOfBirth: "",
      utrNo: "",
      nationalInsuranceNo: "",
      nextOfKin: "",
      email: "",
      mobileNo: "",
      nextOfKinContactNo: "",
      trade: "",
      cscsCpcs: "",
      bankNameAddress: "",
      accountName: "",
      accountNo: "",
      sortCode: "",
      referenceNo: "",
      createdAt: "",
      createdBy: "",
      lastModifiedAt: "",
      lastModifiedBy: ""
    }));
    navigate(
      `/registration`
    );
  };
  // if (loading) {
  //   return (
  //     <Container>
  //       <CircularProgress />
  //     </Container>
  //   );
  // }

  // if (error) {
  //   return (
  //     <Container>
  //       <Typography color="error">
  //         Error fetching data: {error.message}
  //       </Typography>
  //     </Container>
  //   );
  // }
  return (
    <Box sx={{ padding: { xs: 1, sm: 2, md: 2, lg: 2, xl:2 } }}> {/* Reduce overall padding on mobile */}
      <Snackbar
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {`Form saved ${form.id}`}
        </Alert>
      </Snackbar>
      {/* LOGO SECTION */}
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ margin: { xs: 0, sm: 2 } }} // Reduce margin on mobile
      >
        {/* Adjusted to always take 12 columns on mobile for better centering */}
        <Grid item xs={12} display="flex" justifyContent="center">
          <Link href={`/home`}>
            <img
              src="https://portal.hardhats.co.uk/img/Hardhats-Logo.png"
              alt="HardHats Logo"
              // Removed extra margin-right from style
              style={{ width: "150px", marginRight: '1.5rem' }}
            />
          </Link>
        </Grid>
      </Grid>

      {/* FORM TITLE */}
      <Grid item xs={12} sx={{ textAlign: 'center', marginBottom: '1.5rem', padding: '0 8px' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, typography: { xs: 'h6', sm: 'h4' } }}>
          SUBCONTRACTOR REGISTRATION FORM
        </Typography>
      </Grid>

      {/* MAIN CONTENT CONTAINER: Changed outer Grid item to xs={12} */}
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8}> {/* Takes full width on mobile, centers on larger screens */}
          <Grid container spacing={2}>
            <Grid item xs={12}> {/* Full width on all screens */}
              <Grid container spacing={2}>
                {/* SUBCONTRACTOR DETAILS HEADER */}
                <Grid item xs={12} sx={{ backgroundColor: '#f4c800', textAlign: 'center', marginBottom: '1rem' }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, py: 1 }}>
                    SUBCONTRACTOR DETAILS
                  </Typography>
                </Grid>

                {/* NAME FIELDS - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Title: xs={12} for full width on mobile, sm={2} for desktop */}
                    <Grid item xs={12} sm={2}>
                      <label htmlFor="title" style={{ display: "block", marginBottom: 4 }}>Title</label>
                      <select
                        id="title"
                        value={form.title}
                        onChange={handleFieldChange("title")}
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      >
                        <option value="">Select</option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Ms">Ms</option>
                      </select>
                    </Grid>
                    {/* First Name: xs={12} for full width on mobile, sm={3} for desktop */}
                    <Grid item xs={12} sm={3}>
                      <label htmlFor="firstName" style={{ display: "block", marginBottom: 4 }}>First Name</label>
                      <input
                        id="firstName"
                        type="text"
                        value={form.firstName}
                        onChange={handleFieldChange("firstName")}
                        placeholder="Enter first name"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Middle/Other Name: xs={12} for full width on mobile, sm={3} for desktop */}
                    <Grid item xs={12} sm={3}>
                      <label htmlFor="otherName" style={{ display: "block", marginBottom: 4 }}>Middle/Other Name</label>
                      <input
                        id="otherName"
                        type="text"
                        value={form.otherName}
                        onChange={handleFieldChange("otherName")}
                        placeholder="Enter middle/other name"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Surname: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="surname" style={{ display: "block", marginBottom: 4 }}>Surname</label>
                      <input
                        id="surname"
                        type="text"
                        value={form.surname}
                        onChange={handleFieldChange("surname")}
                        placeholder="Enter surname"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* ADDRESS LINES - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Address Line 1: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="address1" style={{ display: "block", marginBottom: 4 }}>Address Line 1</label>
                      <input
                        id="address1"
                        type="text"
                        value={form.address}
                        onChange={handleFieldChange("address1")}
                        placeholder="Enter address line 1"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Address Line 2: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="address2" style={{ display: "block", marginBottom: 4 }}>Address Line 2</label>
                      <input
                        id="address2"
                        type="text"
                        value={form.address}
                        onChange={handleFieldChange("address2")}
                        placeholder="Enter address line 2"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* CITY/COUNTRY/POSTCODE - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Town/City: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="city" style={{ display: "block", marginBottom: 4 }}>Town/City</label>
                      <input
                        id="city"
                        type="text"
                        value={form.address}
                        onChange={handleFieldChange("city")}
                        placeholder="Enter Town/City"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Country: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="country" style={{ display: "block", marginBottom: 4 }}>Country</label>
                      <input
                        id="country"
                        type="text"
                        value={form.address}
                        onChange={handleFieldChange("country")}
                        placeholder="Enter Country"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Postcode: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="zipcode" style={{ display: "block", marginBottom: 4 }}>Postcode</label>
                      <input
                        id="zipcode"
                        type="text"
                        value={form.address}
                        onChange={handleFieldChange("zipcode")}
                        placeholder="Enter Postcode"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* DOB/UTR/NI - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* DOB: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="dateOfBirth" style={{ display: "block", marginBottom: 4 }}>Date of birth</label>
                      <input
                        id="dateOfBirth"
                        type="date"
                        value={form.dateOfBirth}
                        onChange={handleFieldChange("dateOfBirth")}
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* UTR No: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="utrNo" style={{ display: "block", marginBottom: 4 }}>UTR No</label>
                      <input
                        id="utrNo"
                        type="text"
                        value={form.utrNo}
                        onChange={handleFieldChange("utrNo")}
                        placeholder="Enter UTR number"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* National Insurance No.: xs={12} for full width on mobile, sm={4} for desktop */}
                    <Grid item xs={12} sm={4}>
                      <label htmlFor="nationalInsuranceNo" style={{ display: "block", marginBottom: 4 }}>National Insurance No.</label>
                      <input
                        id="nationalInsuranceNo"
                        type="text"
                        value={form.nationalInsuranceNo}
                        onChange={handleFieldChange("nationalInsuranceNo")}
                        placeholder="Enter National Insurance number"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* MOBILE/EMAIL - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Mobile No: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="mobileNo" style={{ display: "block", marginBottom: 4 }}>Mobile No</label>
                      <input
                        id="mobileNo"
                        type="tel"
                        value={form.mobileNo}
                        onChange={handleFieldChange("mobileNo")}
                        placeholder="Enter mobile number"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* E-mail Address: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="email" style={{ display: "block", marginBottom: 4 }}>E-mail Address</label>
                      <input
                        id="email"
                        type="email"
                        value={form.email}
                        onChange={handleFieldChange("email")}
                        placeholder="Enter email address"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* NEXT OF KIN - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Next of Kin Name: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="nextOfKin" style={{ display: "block", marginBottom: 4 }}>Next of Kin</label>
                      <input
                        id="nextOfKin"
                        type="text"
                        value={form.nextOfKin}
                        onChange={handleFieldChange("nextOfKin")}
                        placeholder="Enter next of kin"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Next of Kin Contact No.: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="nextOfKinContactNo" style={{ display: "block", marginBottom: 4 }}>Next of Kin Contact No.</label>
                      <input
                        id="nextOfKinContactNo"
                        type="tel"
                        value={form.nextOfKinContactNo}
                        onChange={handleFieldChange("nextOfKinContactNo")}
                        placeholder="Enter contact number"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* SERVICES SECTION */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* SERVICES HEADER */}
                <Grid item xs={12} sx={{ backgroundColor: '#f4c800', textAlign: 'center', marginTop: '1rem', marginBottom: '1rem' }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, py: 1 }}>
                    SERVICES
                  </Typography>
                </Grid>

                {/* TRADE/CSCS - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Trade: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="trade" style={{ display: "block", marginBottom: 4 }}>Trade</label>
                      <input
                        id="trade"
                        type="text"
                        value={form.trade}
                        onChange={handleFieldChange("trade")}
                        placeholder="Enter trade"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* CSCS/CPCS: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="cscsCpcs" style={{ display: "block", marginBottom: 4 }}>CSCS/CPCS</label>
                      <input
                        id="cscsCpcs"
                        type="text"
                        value={form.cscsCpcs}
                        onChange={handleFieldChange("cscsCpcs")}
                        placeholder="Enter CSCS/CPCS"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* BANKING INFORMATION SECTION */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* BANKING HEADER */}
                <Grid item xs={12} sx={{ backgroundColor: '#f4c800', textAlign: 'center', marginTop: '1rem', marginBottom: '1.5rem' }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, py: 1 }}>
                    BANKING INFORMATION
                  </Typography>
                </Grid>

                {/* Bank Name/Address: Always full width (xs={12}) */}
                <Grid item xs={12}>
                  <label htmlFor="bankNameAddress" style={{ display: "block", marginBottom: 4 }}>Bank/Building Society Name and Address</label>
                  <input
                    id="bankNameAddress"
                    type="text"
                    value={form.bankNameAddress}
                    onChange={handleFieldChange("bankNameAddress")}
                    placeholder="Enter bank/building society name and address"
                    style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                  />
                </Grid>

                {/* Account Name/No - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Account Name: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="accountName" style={{ display: "block", marginBottom: 4 }}>Account Name</label>
                      <input
                        id="accountName"
                        type="text"
                        value={form.accountName}
                        onChange={handleFieldChange("accountName")}
                        placeholder="Enter account name"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Account No: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="accountNo" style={{ display: "block", marginBottom: 4 }}>Account No</label>
                      <input
                        id="accountNo"
                        type="text"
                        value={form.accountNo}
                        onChange={handleFieldChange("accountNo")}
                        placeholder="Enter account number"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Sort Code/Reference No - Optimized for mobile stacking */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {/* Branch Sort Code: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="sortCode" style={{ display: "block", marginBottom: 4 }}>Branch Sort Code</label>
                      <input
                        id="sortCode"
                        type="text"
                        value={form.sortCode}
                        onChange={handleFieldChange("sortCode")}
                        placeholder="Enter sort code"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                    {/* Reference No: xs={12} for full width on mobile, sm={6} for desktop */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="referenceNo" style={{ display: "block", marginBottom: 4 }}>Reference No</label>
                      <input
                        id="referenceNo"
                        type="text"
                        value={form.referenceNo}
                        onChange={handleFieldChange("referenceNo")}
                        placeholder="Enter reference number"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* DISCLAIMER SECTION */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* DISCLAIMER HEADER */}
                <Grid item xs={12} sx={{ backgroundColor: '#f4c800', textAlign: 'center', marginTop: '1rem', marginBottom: '1.5rem' }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, py: 1 }}>
                    DISCLAIMER
                  </Typography>
                </Grid>

                {/* DATA PROTECTION */}
                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: 800, mb: 1 }}>
                    DATA PROTECTION:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1 }}>
                    Please note all information that you are providing and any further information that you provide will be stored on our computer system for the use in administrative, personal, compliance, health and safety, payroll processes including provision of financial services or advice. By signing this form you acknowledge giving your consent to your personal details being used.
                    I confirm that I am self employed and I declare that all the information provided is correct and I understand that should any of my details change, that it is my responsibility to inform Porter Holdings Ltd in writing.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* SIGNATURE CONTAINER */}
            <Grid container justifyContent="center" sx={{ mt: '2rem', mb: '1.5rem' }}>
              <Grid item xs={12} sm={8} md={6}> {/* Use sm={8} or md={6} to prevent it from getting too wide on desktop */}
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Signature:
                </Typography>
                <Box
                  sx={{
                    // Centering for the box itself is no longer needed since it's full width (xs=12)
                    border: '1px solid #000',
                    height: '100px',
                    width: '90%', // Use 100% width on all screens for simpler layout
                    padding: '8px',
                    backgroundColor: '#f9f9f9',
                    textAlign: 'center',
                    lineHeight: '84px',
                    fontStyle: 'italic',
                    color: '#aaa',
                  }}
                >
                  Click or touch here to sign
                </Box>
                <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                  Electronically signed and dated upon submission.
                </Typography>
              </Grid>
            </Grid>

            {/* BUTTONS */}
            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 3 }}>
                <Button variant="outlined" color="inherit" onClick={handleCancel}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateRegistrationFormPage;